import React from 'react';
import './ReviewItem.css';
// @ts-ignore
import checkmarkIcon from '../../image-assets/icon.checkmark.svg';

export interface Review {
  id: string;
  title: string;
  description?: string;
  keys?: number | null;
  assignee?: string;
  completed: boolean;
  created_at?: string;
  last_updated_at?: string;
  owner_user_id?: string;
  owner_name?: string;
  status?: string;
  owner?: string;
}

interface ReviewItemProps {
  review: Review;
  onToggleComplete: (reviewId: string) => void;
  onClick?: () => void;
  className?: string;
}

const ReviewItem: React.FC<ReviewItemProps> = ({ review, onToggleComplete, onClick, className = '' }) => {
  // Function to get user initials for avatar
  const getUserInitial = (name: string) => {
    return name.charAt(0);
  };

  const handleToggleComplete = (e: React.MouseEvent) => {
    e.stopPropagation(); // Stop event propagation
    onToggleComplete(review.id);
  };

  // Default values for optional properties
  const keyCount = Array.isArray(review.keys) ? review.keys.length : (review.keys || 0);
  const ownerName = review.owner_name || 'Unknown';

  return (
    <div 
      className={`review-item ${review.completed ? 'review-completed' : ''} ${className}`}
      onClick={onClick}
    >
      <div className="list-item-inset">
        <div className="review-content">
          <div className="review-title">
            {review.completed && (
              <img 
                src={checkmarkIcon} 
                alt="Completed" 
                className="review-completed-icon" 
              />
            )}
            {review.title}
          </div>
          <div className="review-meta">
            <div className="review-keys">
              <span>{keyCount} keys</span>
            </div>
            <div className="review-owner">
              <span>{ownerName}</span>
              <div className="review-avatar" onClick={handleToggleComplete}>
                {getUserInitial(ownerName)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewItem; 